import { useReactiveVar } from '@apollo/client';
import Dompurify from 'dompurify';

import theme from '@styles/theme';
import { userVar } from '@store/index';
import { getCookie } from '@utils/cookie';

import { FlexBox, EditorContents } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import StyledButton from '@components/styled/StyledButton';

const AgreementModal = ({ isOpen, setWelcomeModal, data }: any) => {
    const userInfo = useReactiveVar(userVar);

    const handleClose = () => {
        userVar({ ...userInfo, agreement: !userInfo.agreement }); // TODO: 임시 처리
        setWelcomeModal(true);
    };
    return (
        <StyledModal
            title="헬로미디어 서비스 개편에 따른 약관 동의 안내"
            isOpen={isOpen}
            closeBtnHandler={handleClose}
            width="630px"
            fontSize={20}
            fontColor={theme.colors.positiveBlue}
            CLOSE={false}
            LOCK_BG
        >
            <EditorContents
                $maxHeight="70vh"
                dangerouslySetInnerHTML={{
                    __html: Dompurify.sanitize(data || '')
                }}
            />
            <FlexBox $justifyContent="flex-end" $margin="40px 0 0">
                <StyledButton
                    title="동의하고 이용하기"
                    width={142}
                    bgColor={theme.colors.positiveBlue}
                    onClick={handleClose}
                />
            </FlexBox>
        </StyledModal>
    );
};

export default AgreementModal;
